
const messageHelper = {
    methods: {

        showError(message, code) {
            this.$swal({
                html: '<div class="d-flex align-items-center"><div class="flex-shrink-0 me-3">' +
                    '<i class="fas fa-info-circle fa-2x text-white"></i></div>' +
                    '<div class="flex-grow-1"><span class="text-white">' +
                    message + '</span></div></div>',
                icon: false,
                position: "bottom-end",
                background: "#E74C3C",
                timer: 7500,
                padding: '5px'
            });
        },
        showMessage(message) {
            this.$swal({
                html: '<div class="d-flex align-items-center"><div class="flex-shrink-0 me-3">' +
                    '<i class="fas fa-check-circle fa-2x text-white"></i></div>' +
                    '<div class="flex-grow-1"><span class="text-white">' +
                    message + '</span></div></div>',
                icon: false,
                position: "bottom-start",
                background: "#029602",
                timer: 7500,
                padding: '5px'
            });
        },
        showInfo(message) {
            this.$swal({
                html: '<div class="d-flex align-items-center"><div class="flex-shrink-0 me-3">' +
                    '<i class="fas fa-info-circle fa-2x text-white"></i></div>' +
                    '<div class="flex-grow-1"><span class="text-white">' +
                    message + '</span></div></div>',
                icon: false,
                position: "bottom-end",
                background: "#3498db",
                timer: 2500,
                padding: '5px'
            });
        },
        showConfirmation(message) {
            return this.$swal({
                toast: false,
                text: message,
                icon: "warning",
                timer: 7500,
                width: "400px",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonColor: "#2ECC71",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                color: "#17202A",
                iconColor: "#d33",
            }).then((confirmation) => {
                if (confirmation.value) {
                    return {
                        result: "Yes",
                    }
                } else {
                    return {
                        result: "No",
                    }
                }
            });
        }

    },

}

export default messageHelper;